(function() { window.GUID_a9ff4686_3fae_4b21_82ae_e4248086dd49 = { getGuid: function() { return "a9ff4686-3fae-4b21-82ae-e4248086dd49"; } }; })();
function SetBehaviorOfEditColumns() {
    $('#TemplateId').on('change', function (e) {
        var selectedTemplateId = $(this).val();
        var gridViewId = $('#GridViewId').val();
        var controllerName = $('#ControllerName').val();
        var eventType = $('#EventType').val();
        var data = {
            gridViewId: gridViewId,
            templateId: selectedTemplateId,
            eventType: eventType
        };
        CompuSport.Ajax.Get(CSParameters.RUrl + controllerName + '/GridViewEditColumnsList/' + CSParameters.SportEventId, data, function (response) {
            $('#ColumnsList').html(response);
            SetBehaviorOfList();
        });
    });
    SetBehaviorOfList();
}
function SetBehaviorOfList() {
    var columns = $('.EditableColumn');
    UpdateArrayOfColumns(columns);
    $('#EditableColumnList').sortable({
        update: function (event, ui) {
            ChangeOrderOfGridViewColumnDrag(columns.length);
            UpdateArrayOfColumns(columns);
        },
        axis: "y",
        items: "> li:gt(0)",
        handle: ".FieldName",
        cursor: "move",
        containment: "parent",
        scroll: true,
    });
    var selectedField = null;
    var selectedColumn = null;
    $('.EditableColumn .FieldName').on('mousedown', function (e) {
        $('.FieldName', columns).removeClass('IsSelected');
        selectedField = $(this);
        selectedField.addClass('IsSelected');
        selectedColumn = $(this).parent();
    });
    $('.EditableColumn .CheckBoxHeaderIsVisible').on('mousedown', function (e) {
        var isVisibleBox = $(this);
        isVisibleBox.toggleClass('IsVisible');
        isVisibleBox.parent().data('visibility', isVisibleBox.hasClass('IsVisible'));
        UpdateArrayOfColumns(columns);
    });
    $('.EditableColumnAll .CheckBoxHeaderIsVisible').on('mousedown', function (e) {
        var isVisibleBox = $(this);
        isVisibleBox.toggleClass('IsVisible');
        $.each(columns, function () {
            if (isVisibleBox.hasClass('IsVisible')) {
                $('.CheckBoxHeaderIsVisible', this).addClass('IsVisible');
                $(this).data('visibility', true);
            }
            else {
                $('.CheckBoxHeaderIsVisible', this).removeClass('IsVisible');
                $(this).data('visibility', false);
            }
        });
        UpdateArrayOfColumns(columns);
    });
    $('#BtnColumnOrderDown').off('mousedown');
    $('#BtnColumnOrderDown').on('mousedown', function (e) {
        ChangeOrderOfGridViewColumn(selectedColumn, false, columns.length);
        UpdateArrayOfColumns(columns);
    });
    $('#BtnColumnOrderUp').off('mousedown');
    $('#BtnColumnOrderUp').on('mousedown', function (e) {
        ChangeOrderOfGridViewColumn(selectedColumn, true, columns.length);
        UpdateArrayOfColumns(columns);
    });
    $('#FieldSearch').off('input.gridViewEditColumns').on('input.gridViewEditColumns', function () {
        let searchedText = String($('#FieldSearch').val() || '').toLowerCase();
        let cols = $('.EditableColumn');
        cols.each((i, e) => {
            const $e = $(e);
            let name = $(e).data('displaytext');
            let isMatch = searchedText.length > 0 && name.toLowerCase().includes(searchedText);
            $e.toggleClass('SearchMatch', isMatch);
            $e.toggleClass('SearchDimmed', searchedText.length > 0 && !isMatch);
        });
    });
}
function ChangeOrderOfGridViewColumn(selectedColumn, goUp, columnsCount) {
    if (selectedColumn != null) {
        var otherColumn = null;
        if (goUp) {
            otherColumn = $(selectedColumn).prev();
            if (otherColumn.hasClass('EditableColumnAll')) {
                return;
            }
            selectedColumn.after(otherColumn);
        }
        else {
            otherColumn = $(selectedColumn).next();
            selectedColumn.before(otherColumn);
        }
        var indexSelColumn = parseInt(selectedColumn.data('order'), 10);
        var indexOtherColumn = parseInt(otherColumn.data('order'), 10);
        if (!isNaN(indexOtherColumn)) {
            selectedColumn.data('order', indexOtherColumn);
            otherColumn.data('order', indexSelColumn);
        }
    }
}
function ChangeOrderOfGridViewColumnDrag(columnsCount) {
    var columns = $('.EditableColumn');
    for (var i = 0; i < columnsCount; i++) {
        $(columns[i]).data('order', i);
    }
}
function UpdateArrayOfColumns(columns) {
    var result = "";
    $.each(columns, function (index, element) {
        var col = $(this);
        var fieldName = col.data('fieldname');
        var size = col.data('size');
        var order = col.data('order');
        var visibility = col.data('visibility');
        result += fieldName + ":" + order + ":" + size + ":" + visibility + ";";
    });
    var CSColsDefinitions = $('#CSColsDefinitions');
    CSColsDefinitions.val(result);
}

//# sourceMappingURL=cs.gridviewedit.js.map
